module.exports = __webpack_public_path__ + "static/media/flow-welcome.a6ddda1b.png";